"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isColumnGapSizeValid = exports.defaultColumnGaps = exports.columnGapRange = void 0;
var _grid = require("../../fuse-responsive-grid/src/grid");
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var columnGapRange = exports.columnGapRange = {
  xxs: Array.from(Array(5).keys()).splice(1),
  // 1-4
  m: Array.from(Array(8).keys()).splice(1),
  // 1-7
  l: Array.from(Array(10).keys()).splice(1),
  // 1-9
  xl: Array.from(Array(12).keys()).splice(1) // 1-11
};
var defaultColumnGaps = exports.defaultColumnGaps = {
  xxs: _grid.gridConfig.xxs.gutter,
  m: _grid.gridConfig.m.gutter,
  l: _grid.gridConfig.l.gutter,
  xl: _grid.gridConfig.xl.gutter
};
var validColumnGapSizes = ['xxs', 'm', 'l', 'xl'];
var isColumnGapSizeValid = exports.isColumnGapSizeValid = function isColumnGapSizeValid(gapSizeSpacingNumber, breakpoint) {
  var maxSize = Math.max.apply(Math, _toConsumableArray(columnGapRange[breakpoint]));
  var isGapValid = gapSizeSpacingNumber > 0 && gapSizeSpacingNumber <= maxSize;
  var isBreakpointValid = validColumnGapSizes.includes(breakpoint);
  return isGapValid && isBreakpointValid;
};